import Layout from "../../layout/Layout";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Button,
  Grid,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import DescriptionIcon from "@mui/icons-material/Description";
import DownloadIcon from "@mui/icons-material/Download";

const ResearchDocuments = () => {
  const { t } = useTranslation("researchDocuments");

  const documents = [
    {
      id: "risk-factor-matrix",
      titleKey: "documents.riskFactorMatrix.title",
      descriptionKey: "documents.riskFactorMatrix.description",
      fileName: "risk_factor_matrix.pdf",
      filePath: "/documents/risk_factor_matrix.pdf",
    },
  ];

  return (
    <Layout>
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 600,
              mb: 2,
              fontSize: { xs: "1.75rem", sm: "2.5rem", md: "3rem" },
            }}
          >
            {t("title")}
          </Typography>
          <Typography
            variant="h6"
            color="text.secondary"
            sx={{ mb: 4, fontSize: { xs: "0.9rem", sm: "1.1rem" } }}
          >
            {t("subtitle")}
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {documents.map((doc) => (
            <Grid item xs={12} md={6} key={doc.id}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: 4,
                  },
                }}
              >
                <CardContent sx={{ flexGrow: 1, p: 3 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <DescriptionIcon
                      sx={{ fontSize: 40, color: "primary.main", mr: 2 }}
                    />
                    <Typography
                      variant="h6"
                      component="h2"
                      fontWeight={500}
                    >
                      {t(doc.titleKey)}
                    </Typography>
                  </Box>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 3 }}
                  >
                    {t(doc.descriptionKey)}
                  </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<DownloadIcon />}
                    href={doc.filePath}
                    download={doc.fileName}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("downloadButton")}
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Layout>
  );
};

export default ResearchDocuments;
